// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".csv-invitation-placeholder[data-v-4224709d] {\n  margin-top: 1.1rem;\n}\n", ""]);
// Exports
module.exports = exports;
